import { offersSlice } from './slice'

// Offers List
export const { setOffersListLoading } = offersSlice.actions
export const { setOffersList } = offersSlice.actions
export const { setOffersFilterText } = offersSlice.actions
export const { filterOffersByText } = offersSlice.actions
export const { filterOffersByOption } = offersSlice.actions
// Decline Offer
export const { setOffersDeclineLoading } = offersSlice.actions
export const { setOffersDeclineSuccess } = offersSlice.actions
export const { resetOffersDeclineState } = offersSlice.actions
// Accept Offer
export const { setOffersAcceptLoading } = offersSlice.actions
export const { setOffersAcceptSuccess } = offersSlice.actions
export const { resetOffersAcceptState } = offersSlice.actions
// Others
export const { updateOfferState } = offersSlice.actions

// Send Request for Proposal
export const { resetRequestForProposalState } = offersSlice.actions
export const { setRequestForProposalLoading } = offersSlice.actions
export const { setRequestForProposalSuccess } = offersSlice.actions
